import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

const Option = ({
  data,
  customDropdownOption = undefined,
  dataTestId = undefined,
  ...props
}) => {
  const isClear = Boolean(data?.isClearOption);
  const content = useMemo(() => {
    if (customDropdownOption) return customDropdownOption(data);
    if (isClear) {
      return (
        <div className="flex items-center text-vamos-gray">
          <span>{data.label}</span>
        </div>
      );
    }
    return (
      <div className="flex flex-col">
        <div className="flex items-center gap-x-1">
          {data.icon && data.icon}
          {data.label}
        </div>
        {data.comment && <div className="text-base text-vamos-gray">{data.comment}</div>}
      </div>
    );
  }, [data, customDropdownOption, isClear]);
  return (
    <components.Option {...props}>
      <div data-testid={dataTestId}>{content}</div>
    </components.Option>
  );
};

Option.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    icon: PropTypes.element,
    comment: PropTypes.string,
    isClearOption: PropTypes.bool,
  }).isRequired,
  customDropdownOption: PropTypes.func,
  dataTestId: PropTypes.string,
};

export default Option;
